import { SelectContent as UiKitSelectContent } from "ics-ui-kit/components/select";
import { type FC, forwardRef } from "react";
import type { ExtractComponentGeneric } from "../../lib/extractComponentGeneric";
import { VIEWPORT_PADDING } from "../../lib/floating";

interface UiKitSelectContentProps extends ExtractComponentGeneric<typeof UiKitSelectContent> {
	maxItems?: number;
}

export const SelectContent: FC<UiKitSelectContentProps> = forwardRef((props, ref) => {
	const { collisionPadding = VIEWPORT_PADDING, ...otherProps } = props;
	return (
		<UiKitSelectContent
			collisionPadding={collisionPadding}
			data-radix-select
			ref={ref}
			{...otherProps}
			data-testid="select-content"
		/>
	);
});
